/**
 * Lets Partnr open a document it just created, the way a click on the card
 * does. The executor asks; the DocumentCard for that item opens its editor
 * and clears the request. S5 can swap the editor without changing this.
 */
import { create } from 'zustand';

interface OpenDocumentState {
  /** Item id whose editor should open, or null */
  requestedId: string | null;
  request: (itemId: string) => void;
  /** Clears the request if it is for this item; true when it was */
  take: (itemId: string) => boolean;
}

export const usePartnrOpenDocumentStore = create<OpenDocumentState>((set, get) => ({
  requestedId: null,
  request: (itemId) => set({ requestedId: itemId }),
  take: (itemId) => {
    if (get().requestedId !== itemId) return false;
    set({ requestedId: null });
    return true;
  },
}));
